module.exports = __webpack_public_path__ + "static/media/social2.70f7b569.png";